import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import Login from "../pages/Login";
import { fetchMe } from "../redux/features/LoginSlice";

export default function AuthGuard({ children }) {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const [requestedLocation, setRequestedLocation] = useState(null);

  const me = useSelector((state) => state.login.me);
  const error = useSelector((state) => state.login.error);

  useEffect(() => {
    dispatch(fetchMe());
  }, [dispatch]);

  if (me === null && error === null) {
    return (
      <div className="flex justify-center h-[calc(100vh-4rem)] items-center">
        <Loading />
      </div>
    );
  }

  if (!me?.id) {
    // TODO: change this to !isAuthenticated
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (!me?.verified) {
    toast.info("Your email has not verified yet. Please verify first.");
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}
